import PropTypes from 'prop-types';
import React from 'react';
import './card.scss';
import clsx from 'clsx';
import Button, { ButtonSizes } from '../button';
import FeaturedIcon, { FeaturedIconSizes } from '../featured-icon';

const Card = ({
  text, supportingText, renderIcon, buttons, onButtonClick, children, className,
}) => {
  const getButtons = () => {
    if (buttons.length) {
      const buttonViews = buttons.map(({
        id, label, type, disabled,
      }) => (
        <Button
          label={label}
          type={type}
          size={ButtonSizes.SMALL}
          onClick={() => onButtonClick(id)}
          key={id}
          disabled={disabled}
        />
      ));

      return (
        <div className="card-buttons">
          {buttonViews}
        </div>
      );
    }

    return null;
  };

  const getCustomView = () => {
    if (children) {
      return <div className="card-custom-view">{children}</div>;
    }
    return null;
  };

  return (
    <div className={clsx('card-cont', className)}>
      <div className="card-header">
        {
          renderIcon
          && <FeaturedIcon renderIcon={renderIcon} size={FeaturedIconSizes.MEDIUM} />
        }
        <div className="card-header-text">{text}</div>
      </div>
      <div className="card-body">
        <div className="card-supporting-text">{supportingText}</div>
        {getCustomView()}
      </div>
      {getButtons()}
    </div>
  );
};

Card.defaultProps = {
  supportingText: '',
  buttons: [],

  renderIcon: null,
  children: null,
  onButtonClick: () => {},
  className: '',
};

Card.propTypes = {
  text: PropTypes.string.isRequired,
  supportingText: PropTypes.string,
  buttons: PropTypes.arrayOf(PropTypes.shape),
  renderIcon: PropTypes.func,
  children: PropTypes.element,
  onButtonClick: PropTypes.func,
  className: PropTypes.string,
};

export default Card;
